import { Timestamp, TranslateFunction } from '@griply/types';
import {
  addDays,
  differenceInDays,
  endOfDay,
  format,
  isBefore,
  isSameDay,
  isSameYear,
} from 'date-fns';

import { getDateLabel } from './get-date-label';

export type GetSmartDateLabelOptions = {
  enableWeekdays?: boolean;
  compactWeekdayDate?: boolean;
};

export const getSmartDateLabel = (
  date: Timestamp,
  today: Timestamp,
  t: TranslateFunction,
  options?: GetSmartDateLabelOptions,
) => {
  if (isSameDay(date, today)) {
    return t('general.labels.dates.today');
  }

  if (options?.enableWeekdays || options?.compactWeekdayDate) {
    if (isSameDay(date, addDays(today, 1))) {
      return t('general.labels.dates.tomorrow');
    }
  }

  if (options?.compactWeekdayDate) {
    const compactFormat = isSameYear(date, today)
      ? 'EEE MMM d'
      : "EEE MMM d, ''yy";
    return format(date, compactFormat);
  }

  if (options?.enableWeekdays) {
    const diff = differenceInDays(endOfDay(date), endOfDay(today));
    if (diff > 1 && diff < 7) {
      return format(date, 'EEEE');
    }
  }

  if (isBefore(date, today)) {
    return t('general.labels.days-ago.mid-short', {
      count: differenceInDays(endOfDay(today), endOfDay(date)),
    });
  }

  return getDateLabel(date, today);
};
